module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wiskey@2x_b43481.jpg";